import { createContext } from 'react'

const ErrorModalContext = createContext({
    openErrorModal: (title: string, text: string, leftButtonTitle: string, leftButtonOnClick: () => void, rightButtonTitle: string, rightButtonOnClick: () => void) => {},
    closeErrorModal: () => {}
});

export { ErrorModalContext };